import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import iconLoadingIA from '../../imagens/ialoading.gif';
import InputMoeda from '../MaskMoney';
import RemoveBackgroundModal from '../RemoveBackgroundModal';

function EditarProduto({ produto, setVisivel, onAddProdutos, user, creditos, setCreditos }) {
  const [form, setForm] = useState({});
  const [imagemParaProcessar, setImagemParaProcessar] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loadingIA, setLoadingIA] = useState(false);
  const [inputbuscar, setInputBuscar] = useState();
  const [imagens, setImagens] = useState([]);
  const [imagensGoogle, setImagensGoogle] = useState([]);
  const [loadingimagens, setLoadingImagens] = useState(false);
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(form.tipopreco);
  const [salvando, setSalvando] = useState(false);
  const [trocarAberto, setTrocarAberto] = useState(true);
  const [mostrarBusca, setMostrarBusca] = useState(false);

  const fileUploadRef = React.useRef(null);

  useEffect(() => {
    if (produto) setForm(produto);
  }, [produto]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function salvarEdicao() {
    setSalvando(true);
    try {
      const response = await fetch('https://videooferta.com/api/editar-produto.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      if (data.success) {
        setVisivel('produtos');
        onAddProdutos();
      } else {
        alert('Erro ao salvar');
      }
    } catch (error) {
      console.error(error);
      alert('Erro de conexão com o servidor');
    } finally {
      setSalvando(false);
    }
  }

  async function atualizarImagemProduto(novaUrl) {
    try {
      const response = await fetch('https://videooferta.com/api/atualizar-imagem.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: form.id, imagem: novaUrl }),
      });
      const data = await response.json();
      if (data.success) {
        setForm((prev) => ({ ...prev, imagem: novaUrl }));
      } else {
        alert('Erro ao atualizar imagem');
      }
    } catch (error) {
      console.error(error);
      alert('Erro ao atualizar imagem no servidor');
    }
  }

  const fazerUpload = () => fileUploadRef.current.click();

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setImagemParaProcessar(file);
    setShowModal(true);
  };

  const processarImagem = async (removerFundo = false) => {
    if (!imagemParaProcessar) return;
    try {
      const formData = new FormData();
      formData.append('imagem', imagemParaProcessar);
      if (removerFundo) {
        setLoadingIA(true);
        await Promise.resolve();
      } else {
        setLoading(true);
        setShowModal(false);
      }
      const endpoint = removerFundo
        ? 'https://videooferta.com/api/removebg.php'
        : 'https://videooferta.com/api/uploadImagem.php';
      const response = await fetch(endpoint, { method: 'POST', body: formData });
      if (!response.ok) throw new Error('Erro ao processar a imagem');
      const data = await response.json();
      if (data?.url) {
        await atualizarImagemProduto(data.url);
      } else {
        alert(data.error || 'Erro ao processar a imagem.');
      }
    } catch (error) {
      console.error(error);
      alert('Erro ao processar a imagem.');
    } finally {
      if (removerFundo) setLoadingIA(false);
      if (!removerFundo) setLoading(false);
      setShowModal(false);
      setImagemParaProcessar(null);
    }
  };

  const buscarImagem = async (termo) => {
    setLoadingImagens(true);
    try {
      const res = await fetch(
        `https://videooferta.com/api/buscarImagemProduto.php?termo=${encodeURIComponent(termo)}`
      );
      const data = await res.json();
      if (Array.isArray(data)) {
        setImagens(data);
      } else {
        setImagens([]);
        alert(data.erro || 'Erro ao buscar imagens.');
      }
    } catch (err) {
      console.error(err);
      alert('Erro na requisição');
      setLoadingImagens(false);
    }
  };

  // Testa se a URL realmente renderiza como imagem antes de oferecê-la ao
  // usuário (hotlink protection, 403, HTML de erro etc. não disparam erro no
  // fetch, só na hora de carregar a imagem de fato).
  const imagemRenderizavel = (url, timeoutMs = 7000) =>
    new Promise((resolve) => {
      const img = new window.Image();
      let resolvido = false;
      const finalizar = (ok) => {
        if (resolvido) return;
        resolvido = true;
        resolve(ok);
      };
      const timer = setTimeout(() => finalizar(false), timeoutMs);
      img.onload = () => {
        clearTimeout(timer);
        finalizar(true);
      };
      img.onerror = () => {
        clearTimeout(timer);
        finalizar(false);
      };
      img.referrerPolicy = 'no-referrer';
      img.src = url;
    });

  const buscarImagemGoogle = async (termo) => {
    if (!termo) return;
    setLoadingGoogle(true);
    setImagensGoogle([]);
    try {
      const res = await fetch(
        `https://videooferta.com/api/buscarImagemGoogle.php?termo=${encodeURIComponent(termo)}`
      );
      const data = await res.json();
      // API pode retornar array de strings (URLs) ou array de objetos {imagem: ...}
      let lista = [];
      if (Array.isArray(data)) {
        lista = data.map((it) =>
          typeof it === 'string' ? { imagem: it } : it
        );
      } else if (Array.isArray(data?.imagens)) {
        lista = data.imagens.map((it) =>
          typeof it === 'string' ? { imagem: it } : it
        );
      } else if (Array.isArray(data?.resultados)) {
        lista = data.resultados.map((it) =>
          typeof it === 'string' ? { imagem: it } : it
        );
      } else {
        alert(data?.erro || 'Nenhum resultado retornado pelo Google.');
        return;
      }

      // Filtra URLs problemáticas (Instagram crawler, Facebook, etc. — exigem auth ou
      // retornam HTML em vez de imagem)
      const DOMINIOS_BLOQUEADOS = [
        'lookaside.instagram.com',
        'lookaside.fbsbx.com',
        'scontent',          // CDNs do Facebook/Instagram que pedem token
        'instagram.com/p/',
        'facebook.com',
        'fbcdn.net',
        'pinimg.com/originals', // pode dar 403
      ];
      lista = lista.filter((it) => {
        const u = String(it.imagem || '').toLowerCase();
        if (!u || !u.startsWith('http')) return false;
        return !DOMINIOS_BLOQUEADOS.some((dom) => u.includes(dom));
      });

      // Descarta imagens que não carregam de verdade (ex.: hotlink protection
      // devolvendo 200 com placeholder, ou 403/HTML no lugar da imagem).
      const carregaveis = await Promise.all(
        lista.map((it) => imagemRenderizavel(it.imagem))
      );
      lista = lista.filter((_, i) => carregaveis[i]);

      if (lista.length === 0) {
        alert('Nenhuma imagem válida encontrada no Google para esse termo.');
      }

      setImagensGoogle(lista);
    } catch (err) {
      console.error(err);
      alert('Erro na busca no Google.');
    } finally {
      setLoadingGoogle(false);
    }
  };

  return (
    <div className="col2 prod-panel">
      {/* ─── Header ─── */}
      <motion.div
        className="prod-header"
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <div className="prod-header__top">
          <div className="prod-header__title-group">
            <button
              className="prod-back-btn"
              onClick={() => setVisivel('produtos')}
            >
              <i className="fa-solid fa-arrow-left" />
            </button>
            <div>
              <h2 className="prod-header__title">Editar produto</h2>
              <p className="prod-header__subtitle">
                {form.titulo || 'Sem nome'}
              </p>
            </div>
          </div>
          <button
            className="prod-header__close"
            onClick={() => setVisivel('')}
            aria-label="Fechar"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
      </motion.div>

      {/* ─── Body ─── */}
      <motion.div
        className="prod-body"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.35 }}
      >
        {/* Imagem do produto */}
        <div className="edit-img-section">
          <div className="edit-img-preview">
            <img
              src={form.imagem}
              alt="Produto"
              className="edit-img-preview__img"
            />
            <input
              type="file"
              ref={fileUploadRef}
              style={{ display: 'none' }}
              accept="image/*"
              onChange={handleUpload}
            />
          </div>

          {/* Accordion "Trocar imagem do Produto" */}
          <div className="trocar-img-accordion">
            <button
              type="button"
              className="trocar-img-accordion__header"
              onClick={() => setTrocarAberto((v) => !v)}
            >
              <span className="trocar-img-accordion__title">
                <i className="fa-solid fa-camera-rotate" />
                Trocar imagem do Produto
              </span>
              <i
                className={`fa-solid ${
                  trocarAberto ? 'fa-chevron-up' : 'fa-chevron-down'
                }`}
              />
            </button>

            {trocarAberto && (
              <motion.div
                className="trocar-img-accordion__body"
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
              >
                {/* Opção 1 — buscar no banco */}
                <button
                  type="button"
                  className="trocar-img-option"
                  onClick={() => {
                    setMostrarBusca((v) => {
                      const novo = !v;
                      if (novo && form.titulo) {
                        setInputBuscar(form.titulo);
                        buscarImagem(form.titulo);
                      }
                      return novo;
                    });
                  }}
                >
                  <span className="trocar-img-option__icon">
                    <i className="fa-solid fa-database" />
                  </span>
                  <span className="trocar-img-option__texts">
                    <strong>Buscar no banco de dados</strong>
                    <small>Pesquise em nossa galeria de produtos</small>
                  </span>
                </button>

                {mostrarBusca && (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      buscarImagem(inputbuscar);
                    }}
                    className="edit-img-search"
                    style={{ marginTop: 8 }}
                  >
                    <div className="edit-img-search__wrap">
                      <i className="fa-solid fa-database edit-img-search__icon" />
                      <input
                        type="text"
                        placeholder="Buscar no banco de dados..."
                        value={inputbuscar || ''}
                        onChange={(e) => setInputBuscar(e.target.value)}
                        className="edit-img-search__input"
                      />
                      <button type="submit" className="edit-img-search__btn">
                        Buscar
                      </button>
                    </div>
                  </form>
                )}

                {mostrarBusca && imagens.length > 0 && (
                  <motion.div
                    className="edit-img-results"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                  >
                    {imagens.map((img, i) => (
                      <img
                        key={i}
                        src={img.imagem}
                        onClick={() => {
                          atualizarImagemProduto(img.imagem);
                          setLoadingImagens(false);
                        }}
                        className="edit-img-results__item"
                        alt="Resultado"
                      />
                    ))}
                  </motion.div>
                )}

                {mostrarBusca && (
                  <p
                    className="add-web-search-btn"
                    style={{
                      cursor: 'default',
                      marginTop: 10,
                      marginBottom: 0,
                      fontSize: 13,
                      display: 'block',
                      textAlign: 'center',
                      lineHeight: 1.45,
                      color: '#5C4A63',
                      background: '#F5EDFA',
                      border: '1px solid #E8E1EF',
                      borderRadius: 12,
                      padding: '12px 16px',
                    }}
                  >
                    Não encontrou o que queria?{' '}
                    <span
                      style={{
                        color: 'rgb(115, 32, 124)',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() => {
                        const termo = inputbuscar || form.titulo || '';
                        if (!termo) return;
                        buscarImagemGoogle(termo);
                      }}
                    >
                      Clique aqui
                    </span>{' '}
                    para buscar mais resultados no Google.
                  </p>
                )}

                {mostrarBusca && (loadingGoogle || imagensGoogle.length > 0) && (
                  <>
                    <div className="edit-img-divider">
                      <i className="fa-brands fa-google" />
                      <span>Resultados do Google</span>
                    </div>
                    {loadingGoogle && (
                      <div style={{ textAlign: 'center', padding: 12, color: '#5C4A63', fontSize: 13 }}>
                        Buscando no Google...
                      </div>
                    )}
                    {imagensGoogle.length > 0 && (
                      <motion.div
                        className="edit-img-results"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                      >
                        {imagensGoogle.map((img, i) => (
                          <img
                            key={`g-${i}`}
                            src={img.imagem}
                            onClick={() => {
                              // Imagens do Google geralmente têm fundo — abre modal de remoção
                              setImagemParaProcessar(img.imagem);
                              setShowModal(true);
                            }}
                            onError={(e) => {
                              // Remove imagens quebradas/bloqueadas (CORS, 403, hotlink)
                              e.currentTarget.style.display = 'none';
                            }}
                            referrerPolicy="no-referrer"
                            loading="lazy"
                            className="edit-img-results__item"
                            alt="Resultado Google"
                          />
                        ))}
                      </motion.div>
                    )}
                  </>
                )}

                {/* Opção 2 — enviar imagem */}
                <button
                  type="button"
                  className="trocar-img-option"
                  onClick={fazerUpload}
                >
                  <span className="trocar-img-option__icon">
                    <i className="fa-solid fa-cloud-arrow-up" />
                  </span>
                  <span className="trocar-img-option__texts">
                    <strong>Enviar imagem</strong>
                    <small>Faça upload do seu dispositivo</small>
                  </span>
                </button>
              </motion.div>
            )}
          </div>
        </div>

        {/* Formulário */}
        <div className="edit-form">
          <div className="edit-field">
            <label className="edit-label">Nome do produto</label>
            <input
              type="text"
              name="titulo"
              className="edit-input"
              value={form.titulo || ''}
              onChange={handleChange}
              placeholder="Ex: Arroz Tipo 1 5kg"
            />
          </div>

          <div className="edit-row">
            <div className="edit-field" style={{ flex: 1 }}>
              <label className="edit-label">Unidade</label>
              <select
                name="unidade"
                className="edit-input"
                value={form.unidade || ''}
                onChange={handleChange}
              >
                <option value="">Nenhuma</option>
                <option value="unidade">Unidade</option>
                <option value="kg">Quilo (kg)</option>
                <option value="cada">Grama (g)</option>
                <option value="l">Litro (l)</option>
                <option value="ml">Mililitro (ml)</option>
                <option value="caixa">Caixa</option>
                <option value="pacote">Pacote</option>
                <option value="bandeja">Bandeja</option>
                <option value="duzia">Duzia</option>
              </select>
            </div>

            <div className="edit-field" style={{ flex: 1 }}>
              <label className="edit-label">Tipo de preço</label>
              <select
                className="edit-input"
                name="tipopreco"
                value={form.tipopreco || ''}
                onChange={(e) => {
                  handleChange(e);
                  setSelectedOption(e.target.value);
                }}
              >
                <option value="simples">Simples</option>
                <option value="dexpory">De X Por Y</option>
                <option value="levexpaguey">Leve X Pague Y</option>
                <option value="parcelado">Parcelado</option>
                <option value="customizado">Customizado</option>
              </select>
            </div>
          </div>

          {/* Campos de preço dinâmicos */}
          <motion.div
            key={form.tipopreco}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            className="edit-price-section"
          >
            {form.tipopreco === 'simples' && (
              <div className="edit-field">
                <label className="edit-label">Preço</label>
                <InputMoeda
                  className="edit-input"
                  initialValue={form?.preco || '0,00'}
                  name="preco"
                  onChange={handleChange}
                />
              </div>
            )}

            {form.tipopreco === 'dexpory' && (
              <div className="edit-row">
                <div className="edit-field" style={{ flex: 1 }}>
                  <label className="edit-label">De</label>
                  <InputMoeda
                    className="edit-input"
                    initialValue={form?.precode || '0,00'}
                    name="precode"
                    onChange={handleChange}
                  />
                </div>
                <div className="edit-field" style={{ flex: 1 }}>
                  <label className="edit-label">Por</label>
                  <InputMoeda
                    className="edit-input"
                    initialValue={form?.precopor || '0,00'}
                    name="precopor"
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}

            {form.tipopreco === 'levexpaguey' && (
              <div className="edit-row">
                <div className="edit-field" style={{ flex: 2 }}>
                  <label className="edit-label">Título desconto</label>
                  <input
                    type="text"
                    className="edit-input"
                    defaultValue={form?.titulodesconto}
                    name="titulodesconto"
                    onChange={handleChange}
                  />
                </div>
                <div className="edit-field" style={{ flex: 1 }}>
                  <label className="edit-label">Preço</label>
                  <InputMoeda
                    className="edit-input"
                    initialValue={form?.precodesconto || '0,00'}
                    name="precodesconto"
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}

            {form.tipopreco === 'parcelado' && (
              <>
                <div className="edit-row">
                  <div className="edit-field" style={{ flex: 2 }}>
                    <label className="edit-label">Título preço normal</label>
                    <input
                      type="text"
                      className="edit-input"
                      defaultValue={form?.titulopreconormal}
                      name="titulopreconormal"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="edit-field" style={{ flex: 1 }}>
                    <label className="edit-label">Preço normal</label>
                    <InputMoeda
                      className="edit-input"
                      initialValue={form?.precoavista || '0,00'}
                      name="precoavista"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="edit-row">
                  <div className="edit-field" style={{ flex: 2 }}>
                    <label className="edit-label">Título parcelado</label>
                    <input
                      type="text"
                      className="edit-input"
                      defaultValue={form?.tituloprecoparcelado}
                      name="tituloprecoparcelado"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="edit-field" style={{ flex: 1 }}>
                    <label className="edit-label">Preço parcelado</label>
                    <InputMoeda
                      className="edit-input"
                      initialValue={form?.precoparcelado || '0,00'}
                      name="precoparcelado"
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </>
            )}

            {form.tipopreco === 'customizado' && (
              <div className="edit-field">
                <label className="edit-label">Texto customizado</label>
                <input
                  type="text"
                  className="edit-input"
                  defaultValue={form?.precocustomizado}
                  name="precocustomizado"
                  onChange={handleChange}
                />
              </div>
            )}
          </motion.div>

          {/* Validade */}
          <div className="edit-section-divider">
            <span>Validade da oferta</span>
          </div>

          <div className="edit-row">
            <div className="edit-field" style={{ flex: 1 }}>
              <label className="edit-label edit-label--sm">Data início</label>
              <input
                type="date"
                name="validade_inicio"
                className="edit-input"
                value={form.validade_inicio || ''}
                onChange={handleChange}
              />
            </div>
            <div className="edit-field" style={{ flex: 1 }}>
              <label className="edit-label edit-label--sm">Data final</label>
              <input
                type="date"
                name="validade_final"
                className="edit-input"
                value={form.validade_final || ''}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Observações */}
          <div className="edit-field">
            <label className="edit-label">Observações</label>
            <textarea
              name="observacoes"
              className="edit-input edit-textarea"
              rows="3"
              placeholder="Adicione observações sobre o produto..."
              value={form.observacoes || ''}
              onChange={handleChange}
            />
          </div>

          {/* Salvar */}
          <button
            className="edit-save-btn"
            onClick={salvarEdicao}
            disabled={salvando}
          >
            {salvando ? (
              <>
                <span className="prod-spinner-sm" /> Salvando...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" /> Salvar alterações
              </>
            )}
          </button>
        </div>
      </motion.div>

      {/* Modal remover fundo */}
      <RemoveBackgroundModal
        open={showModal}
        onClose={() => { setShowModal(false); setImagemParaProcessar(null); }}
        source={imagemParaProcessar}
        userId={user?.id}
        creditos={creditos}
        onCreditosUpdate={(novo) => setCreditos && setCreditos(novo)}
        onConfirm={async (resultado) => {
          try {
            setLoading(true);
            let urlFinal = null;
            if (typeof resultado === 'string') {
              if (resultado.startsWith('data:')) {
                const blob = await (await fetch(resultado)).blob();
                const fd = new FormData();
                fd.append('imagem', blob, 'sem-fundo.png');
                const up = await fetch('https://videooferta.com/api/uploadImagem.php', {
                  method: 'POST', body: fd,
                });
                const upJ = await up.json();
                if (upJ?.url) urlFinal = upJ.url;
              } else {
                urlFinal = resultado;
              }
            } else {
              const fd = new FormData();
              fd.append('imagem', resultado);
              const up = await fetch('https://videooferta.com/api/uploadImagem.php', {
                method: 'POST', body: fd,
              });
              const upJ = await up.json();
              if (upJ?.url) urlFinal = upJ.url;
            }
            if (!urlFinal) throw new Error('URL não retornada');
            await atualizarImagemProduto(urlFinal);
          } catch (e) {
            console.error(e);
            alert('Erro ao salvar imagem.');
          } finally {
            setLoading(false);
          }
        }}
      />
    </div>
  );
}

export default EditarProduto;
